import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Catalogs_ds_get_material_count_by_project_id_and_catalog_idService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { catalog_id?: number, project_id?: number }): 
  Promise<{ result: { material_count?: number } }> 
  {
    let url = `${environment.backendUrl}api/Catalogs/datasources/ds_get_material_count_by_project_id_and_catalog_id/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      catalog_id?: number, project_id?: number    }) {
      return false;
    }
}
